import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import plugins from '../plugins/plugins.js'

export default async (path) => {
  const { fs } = plugins
  const [promise, { resolve, reject }] = resolvable()

  fs(path, r => r.createReader().readEntries(resolve), reject)

  return promise
}
